import { CodedError } from '../../CodedError';
import { bpErrorsCodes } from '../errorCodes';

export class ProductCategoryAlreadyExistsError extends CodedError {
  static get errorName() {
    return bpErrorsCodes.productCategoryAlreadyExistsError.name;
  }

  constructor(message = bpErrorsCodes.productCategoryAlreadyExistsError.message) {
    super(message);
    this.code = bpErrorsCodes.productCategoryAlreadyExistsError.code;
    this.name = bpErrorsCodes.productCategoryAlreadyExistsError.name;
  }
}